import { makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroMovimentosEncaminhadosPje extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Movimento Encaminhado ao PJe';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        return registro.movimentosTransferidos;
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }

    get isHabilitado() {
        return this.store.existeSessaoPJe;
    }
}
